import { render, staticRenderFns } from "./CutInternet.vue?vue&type=template&id=1cbb9a8a"
import script from "./CutInternet.vue?vue&type=script&lang=js"
export * from "./CutInternet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports